import {
  TUTORIAL_SPLASH_IDS,
  type TutorialSplashId,
} from '../onboarding/tutorialSplash/tutorialSplashIds';

export type TutorialSplashStatuses = Record<TutorialSplashId, boolean>;

export const DEFAULT_TUTORIAL_SPLASH_STATUSES: TutorialSplashStatuses = {
  [TUTORIAL_SPLASH_IDS.trainingHint]: false,
  [TUTORIAL_SPLASH_IDS.explorer]: false,
  [TUTORIAL_SPLASH_IDS.games]: false,
  [TUTORIAL_SPLASH_IDS.replay]: false,
  [TUTORIAL_SPLASH_IDS.replayAutoplaySettings]: false,
};

export function normalizeTutorialSplashes(
  value: Partial<Record<string, boolean>> | undefined,
): TutorialSplashStatuses {
  return {
    [TUTORIAL_SPLASH_IDS.trainingHint]:
      value?.[TUTORIAL_SPLASH_IDS.trainingHint] === true,
    [TUTORIAL_SPLASH_IDS.explorer]:
      value?.[TUTORIAL_SPLASH_IDS.explorer] === true,
    [TUTORIAL_SPLASH_IDS.games]: value?.[TUTORIAL_SPLASH_IDS.games] === true,
    [TUTORIAL_SPLASH_IDS.replay]: value?.[TUTORIAL_SPLASH_IDS.replay] === true,
    [TUTORIAL_SPLASH_IDS.replayAutoplaySettings]:
      value?.[TUTORIAL_SPLASH_IDS.replayAutoplaySettings] === true,
  };
}
